/** @format */

import * as React from "react";
import { Flex, Image, Text, useMediaQuery, Stack } from "@chakra-ui/react";
import { commonInfo } from "@common/en";
import colors from "@src/style/colors";
import dompurify from "dompurify";
import theme from "@src/style/theme";

export const Value_EN: React.FC = () => {
  const [isSmall] = useMediaQuery([`(max-width: ${theme.breakpoints.md})`]);
  const sanitizer = dompurify.sanitize;

  const basePaddingX = {
    base: "20px",
    sm: "20px",
    md: "65px",
    lg: "108px"
  };
  const basePaddingY = {
    base: "50px",
    sm: "70px",
    md: "80px",
    lg: "100px"
  };

  return (
    <Flex
      position={"static"}
      width={"100%"}
      flexDirection={"row"}
      justifyContent={"center"}
      alignItems={"center"}
      bgColor={colors.newGray}
      paddingX={basePaddingX}
      paddingY={basePaddingY}>
      <Flex
        width={"100%"}
        maxWidth={theme.breakpoints.mx}
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"stretch"}>
        <Text
          textAlign={"center"}
          color={colors.black}
          wordBreak={"keep-all"}
          fontSize={{
            base: "24px",
            sm: "32px",
            md: "42px",
            lg: "52px",
            xl: "64px"
          }}
          fontWeight={700}
          mb={{ base: "24px", sm: "40px", md: "60px", lg: "80px" }}
          dangerouslySetInnerHTML={{
            __html: sanitizer(
              isSmall ? commonInfo.value.title : commonInfo.value.title_else
            )
          }}
        />
        <Flex
          flexWrap={isSmall ? "nowrap" : "wrap"}
          flexDirection={isSmall ? "column" : "row"}
          justifyContent={"center"}
          alignItems={isSmall ? "stretch" : "center"}
          gap={{ base: "40px", sm: "60px", md: "20px", lg: "36px" }}>
          {commonInfo.value.items.map((item, index) => (
            <Flex
              key={index}
              overflow={"hidden"}
              direction={"column"}
              justifyContent={"stretch"}
              width={{
                base: "100%",
                md: "calc(50% - 10px)",
                lg: "calc(50% - 18px)"
              }}
              boxShadow={"xl"}
              borderRadius={"24px"}
              bgColor={colors.white}>
              <Image
                width={"100%"}
                height={{
                  base: "180px",
                  sm: "240px",
                  md: "240px",
                  lg: "275px"
                }}
                objectFit={"cover"}
                src={item.img}
                bgColor={colors.black}
              />
              <Flex
                flexGrow={1}
                flexDirection={"column"}
                justifyContent={"space-between"}
                alignItems={"baseline"}
                boxSizing={"content-box"}
                height={{
                  base: "180px",
                  sm: "240px",
                  md: "240px",
                  lg: "275px"
                }}
                paddingX={{
                  base: "16px",
                  sm: "36px"
                }}
                paddingTop={{
                  base: "20px",
                  sm: "32px",
                  md: "40px",
                  lg: "32px"
                }}
                paddingBottom={{
                  base: "30px",
                  sm: "40px",
                  md: "40px",
                  lg: "32px"
                }}>
                <Text
                  color={colors.black}
                  wordBreak={"keep-all"}
                  fontSize={{
                    base: "20px",
                    sm: "32px",
                    md: "22px",
                    lg: "32px"
                  }}
                  fontWeight={"700"}
                  dangerouslySetInnerHTML={{
                    __html: sanitizer(item.title)
                  }}
                />
                <Text
                  color={colors.black}
                  wordBreak={"keep-all"}
                  fontSize={{
                    base: "14px",
                    sm: "18px",
                    md: "18px",
                    lg: "20px"
                  }}
                  fontWeight={"400"}
                  dangerouslySetInnerHTML={{
                    __html: sanitizer(item.description)
                  }}
                />
              </Flex>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Value_EN;
